import { render } from "./HideIcon.vue?vue&type=template&id=4b5d5d24"
import script from "./HideIcon.vue?vue&type=script&lang=js"
export * from "./HideIcon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__